export const primaryYellow = '#ffcb05';
export const primaryRed = '#db2b3a';
export const primaryGreen = '#a6ce39';
export const secondaryYellowLight1 = '#ffe06b';
export const secondaryGreenLight1 = '#c5df7d';
export const secondaryRedLight1 = '#e7747d';
export const secondaryLightBlueLight1 = '#4cdaf4';
export const secondaryOrangeLight1 = '#f68f51';
export const secondaryRedDark1 = '#B41F2B';
